import * as React from 'react';

function PlaceholderRegistrationCertificateBack(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg id="registration-back-placeholder" viewBox="0 0 800 500" {...props}>
			<g id="registration-back-placeholder-original">
				<switch>
					<g>
						<path opacity={0.2} fill="currentColor" d="M.177.505h799.599v499.453H.177z" />
						<path
							opacity={0.4}
							fill="currentColor"
							d="M650.943 418.611H148.39c-12.699 0-22.994-10.295-22.994-22.994V97.685c0-12.699 10.295-22.994 22.994-22.994h502.553c12.699 0 22.994 10.295 22.994 22.994v297.932c0 12.699-10.295 22.994-22.994 22.994z"
						/>
						<path
							opacity={0.4}
							fill="currentColor"
							d="M157.148 90.72h23.975v10.862h-23.975zM403.379 154.048h21.983v10.862h-21.983zM403.379 170.096h21.983v10.862h-21.983zM403.379 186.143h21.983v10.862h-21.983zM403.379 202.191h14.311v10.862h-14.311zM403.379 329.334h14.311v10.862h-14.311zM403.379 218.238h21.983V229.1h-21.983zM403.379 234.285h21.983v10.862h-21.983zM403.379 250.333h21.983v10.862h-21.983zM403.379 265.22h21.983v10.862h-21.983zM403.379 281.191h21.983v10.862h-21.983zM403.379 297.239h21.983v10.862h-21.983zM200.963 90.72h36.65v10.862h-36.65zM200.963 105.906h27.868v10.862h-27.868zM200.963 121.954h111.473v10.862H200.963zM200.963 138.001h39.114v10.862h-39.114zM439.302 154.048h39.114v10.862h-39.114zM438.149 170.568h19.557v10.862h-19.557zM438.149 186.143h66.517v10.862h-66.517zM438.149 218.238h33.258V229.1h-33.258zM438.149 250.333h33.258v10.862h-33.258zM438.149 265.22h33.258v10.862h-33.258zM438.149 281.191h66.517v10.862h-66.517zM438.149 297.163h66.517v10.862h-66.517zM438.149 329.334h103.215v10.862H438.149zM200.963 154.048h127.483v10.862H200.963zM241.89 170.096h78.426v10.862H241.89zM200.963 202.191h40.927v10.862h-40.927zM200.963 234.285H256.7v10.862h-55.737zM200.963 250.333h81.854v10.862h-81.854zM200.963 266.38h141.102v10.862H200.963zM200.963 281.191h121.828v10.862H200.963zM200.963 297.239h116.172v10.862H200.963zM200.963 329.334h30.563v10.862h-30.563zM292.227 329.334h30.563v10.862h-30.563zM332.196 329.334h30.563v10.862h-30.563zM200.963 344.763h225.703v10.862H200.963zM267.54 314.319h79.938v10.862H267.54zM157.148 106.895h23.975v10.862h-23.975zM157.148 138.001h23.975v10.862h-23.975zM157.148 154.048h11.988v10.862h-11.988zM157.148 170.096h43.814v10.862h-43.814zM157.148 186.143h23.975v10.862h-23.975zM157.148 202.191h11.988v10.862h-11.988zM157.148 218.238h11.988V229.1h-11.988zM157.148 234.285h23.975v10.862h-23.975zM157.148 250.333h23.975v10.862h-23.975zM157.148 266.38h23.975v10.862h-23.975zM157.148 282.428h10.862v10.862h-10.862zM157.148 298.475h23.975v10.862h-23.975zM157.148 314.522h105.931v10.862H157.148zM157.148 330.57h23.975v10.862h-23.975zM157.148 346.617h23.975v10.862h-23.975z"
						/>
						<path fill="none" d="M201.361 360.192h32.837v14.112h-32.837z" />
						<text
							transform="translate(201.361 372.075)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M201.361 374.304h32.837v14.112h-32.837z" />
						<text
							transform="translate(201.361 386.187)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M201.361 391.724h32.837v14.112h-32.837z" />
						<text
							transform="translate(201.361 403.606)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M201.361 216.613h32.837v14.112h-32.837z" />
						<text
							transform="translate(201.361 228.496)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M439.302 200.566h32.837v14.112h-32.837z" />
						<text
							transform="translate(439.302 212.448)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M439.302 232.66h32.837v14.112h-32.837z" />
						<text
							transform="translate(439.302 244.543)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M201.361 184.518h32.837v14.112h-32.837z" />
						<text
							transform="translate(201.361 196.4)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path fill="none" d="M207.24 168.471h32.837v14.112H207.24z" />
						<text
							transform="translate(207.24 180.353)"
							opacity={0.4}
							fill="currentColor"
							fontFamily="'DINAlternate-Bold'"
							fontSize={13.558}
						>
							{'XXXX'}
						</text>
						<path
							opacity={0.4}
							fill="none"
							stroke="currentColor"
							strokeWidth={3.087}
							strokeMiterlimit={10}
							d="M628.325 301h-62.751c-8.798 0-15.93-7.132-15.93-15.93V117.09c0-8.798 7.132-15.93 15.93-15.93h62.751c8.798 0 15.93 7.132 15.93 15.93v167.98c0 8.798-7.132 15.93-15.93 15.93z"
						/>
						<path
							opacity={0.4}
							fill="none"
							stroke="currentColor"
							strokeWidth={4.117}
							strokeLinecap="round"
							strokeMiterlimit={10}
							d="M576.152 107.075h41.468"
						/>
						<circle opacity={0.4} fill="currentColor" cx={596.949} cy={291.268} r={4.645} />
						<path opacity={0.4} fill="currentColor" d="M553.952 114.447h84.635v166.744h-84.635z" />
					</g>
				</switch>
			</g>
		</svg>
	);
}

export const MemoPlaceholderRegistrationCertificateBack = React.memo(
	PlaceholderRegistrationCertificateBack
);
